import { type PhoneProviderProps, getPhoneStoreState } from '@hit/react-jssip';
import { useCallback } from 'react';

import { reportCallAnswerFailure } from '@/utils/sentry-helper';

export const useOnAnswerFailure = () => {
  const onAnswerFailure = useCallback<
    NonNullable<PhoneProviderProps['onAnswerFailure']>
  >((params) => {
    const { wsConnectionState, extensionState } = getPhoneStoreState();

    reportCallAnswerFailure({
      type: params.type,
      callId: params.callId,
      jssipSessionStatus: params.jssipSessionStatus,
      error: params.error,
      wsConnectionState,
      extensionState,
    });
  }, []);

  return onAnswerFailure;
};
